<template>
	<label class="sk-checkbox" @click="updateModel">
		<input type="checkbox" v-model="model" />
		<span>
			<i class="sk-icon-check-regular"></i>
		</span>
	</label>
</template>

<style>
.sk-checkbox-wrapper {
	display: flex;
	align-items: center;
}

.sk-checkbox-wrapper span {
	color: var(--sk-grey3);
	font-size: 12px;
}
</style>

<style scoped>
.sk-checkbox {
	margin-bottom: 0;
	width: 15px;
	height: 15px;
	position: relative;
	margin-right: 10px;
}

.sk-checkbox input {
	display: none;
}

.sk-checkbox span {
	width: 100%;
	height: 100%;
	background-color: var(--gR-white);
	border: 1px solid var(--sk-grey2);
	position: absolute;
	top: 0;
	left: 0;
	border-radius: 4px;
	transition: background 0.15s ease-in, border 0.15s ease-in;
}

.sk-checkbox span i {
	opacity: 0;
	transition: opacity 0.15s ease-in;
	height: 100%;
	width: 100%;
	font-size: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 1px;
	color: var(--gR-white);
}

.sk-checkbox input:checked + span {
	background: var(--gR-base-90);
	color: var(--gR-white);
	border: 0;
}

.sk-checkbox input:checked + span i {
	opacity: 1;
	height: 100%;
	width: 100%;
	font-size: 10px;
}
</style>

<script>
export default {
	name: "SkCheckbox",
	props: {
		checked: Boolean,
		disabled: Boolean,
		value: null
	},
	computed: {
		model: {
			get() {
				return this.value
			},
			set(val) {
				this.$emit("input", val)
			}
		}
	},
	methods: {
		updateModel() {
			this.model = this.option
		}
	}
}
</script>